import { render } from "./datalayer-event.vue?vue&type=template&id=19fc3d6e"
import script from "./datalayer-event.vue?vue&type=script&lang=js"
export * from "./datalayer-event.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__